import React from "react";
import { isUnscheduledLiveShift } from "../utils/constants";

const CareWatchUnscheduledBadge = ({ row, item }) => {
  if (!isUnscheduledLiveShift(row || item || {})) return null;

  return (
    <span className="care-watch-unscheduled-badge" title="Worker started this shift without a published roster">
      Unscheduled
    </span>
  );
};

export default CareWatchUnscheduledBadge;
